import { RspConfirmationModel } from '../../api/models/rsp/RspConfirmationModel';
import { FieldModel, FieldProp } from '../../components/form/pageForm/types';

const rspVariationHeaderContent: FieldModel<RspConfirmationModel> = {
    component: 'content',
    label: '',
    name: 'rspVariationHeaderContent',
    contentKey: ['BeginRspVariation'],
};

const financialYear: FieldModel<RspConfirmationModel> = {
    component: 'selectInput',
    label: 'Please select the financial year for your RSP application',
    name: 'financialYear',
    maxWidth: '255px',
    contentKey: ['RenewRspFinancialYear'],
    componentProps: {
        id: 'financialYear',
        toggleName: 'Please Select',
        options: [],
    },
};

const applicationFinancialYear: FieldProp<RspConfirmationModel> = {
    rspVariationHeaderContent,
    financialYear,
};

export default applicationFinancialYear;
